<template>
  <div class="content">
    <es-exception
      v-if="!historyRecords.length"
      exceptionMessage="No results found."
      margin="0rem"
      style="padding: 6.5rem"
    />
    <div v-else class="table-wrapper">
      <table class="table is-hoverable is-fullwidth">
        <es-sorter
          @updateSorter="updateSorter"
          :apiSorter="apiSorter"
          :columnHeaders="enabledColumnHeaders"
        />
        <person-profile-history-row
          v-for="record in historyRecords"
          :enabledRaces="enabledRaces"
          :isRetired="isRetired"
          :key="record.id"
          :person="person"
          :record="record"
        />
      </table>
    </div>
    <div class="pager-container" v-if="historyRecords.length">
      <es-pager :totalCount="totalHistoryRecords"/>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import EsException from '@/components/EsException.vue';
import EsPager from '@/components/EsPager.vue';
import EsSorter from '@/components/EsSorter.vue';
import PersonProfileHistoryRow from '@/components/PersonProfileHistoryRow.vue';

export default {
  components: {
    EsException,
    EsPager,
    EsSorter,
    PersonProfileHistoryRow,
  },
  props: {
    columnHeaders: {
      type: Array,
      required: true,
    },
    historyRecords: {
      type: Array,
      required: true,
    },
    isRetired: {
      type: Boolean,
      default: false,
    },
    person: {
      type: Object,
      required: true,
    },
    sortField: {
      type: String,
      default: 'lastUpdateDate',
    },
    sortOrder: {
      type: String,
      default: 'DESC',
    },
    totalHistoryRecords: {
      type: Number,
    },
  },
  created() {
    this.initializeEnabledRaces();
    this.enabledColumnHeaders = this.columnHeaders.filter(a => a.show === true);
  },
  data() {
    return {
      apiSorter: {},
      enabledRaces: [],
      enabledColumnHeaders: [],
    };
  },
  computed: {
    ...mapGetters('propertiesModule', [
      'properties',
    ]),
    ...mapGetters('fieldLabelsModule', [
      'getFieldEnabledForPersonType',
    ]),
    contextMode() {
      const identityControl = this.properties['IDENTITY_CONTROL-LIFETIME_IDS'];
      return JSON.parse(identityControl.toString().toLowerCase()) === false;
    },
  },
  methods: {
    fieldEnabled(code) {
      return this.getFieldEnabledForPersonType(code, 'ASSIGN', this.person.personType);
    },
    getSorter() {
      return this.columnHeaders.find(header => header.order);
    },
    initializeEnabledRaces() {
      const raceFields = ['RACE_ETHNIC_CODE', 'RACE2_CODE', 'RACE3_CODE', 'RACE4_CODE', 'RACE5_CODE'];
      this.enabledRaces = raceFields.filter(rf => this.fieldEnabled(rf));
    },
    updateSorter() {
      this.$emit('updateSorter');
    },
  },
};
</script>

<style lang="sass" scoped>
  .table-wrapper
    overflow-x: auto
  .pager-container
    border-bottom: 1px solid #dee2e6
    border-width: 1px 0 0
    padding: 5.6px 12px
    background-color: #f9f9f9
</style>
